import { EnglishIcon } from 'components/ui-kit/icons/iconComponents/EnglishIcon'
import { FrenchIcon } from 'components/ui-kit/icons/iconComponents/FrenchIcon'
import { GermanIcon } from 'components/ui-kit/icons/iconComponents/GermanIcon'
import { PortugalIcon } from 'components/ui-kit/icons/iconComponents/PortugalIcon'
import { RussianIcon } from 'components/ui-kit/icons/iconComponents/RussianIcon'
import { SpanishIcon } from 'components/ui-kit/icons/iconComponents/SpanishIcon'

/* ==========================================================================
  LANGUAGES
  ========================================================================== */
const LANGUAGES = [
  { label: 'English', languageCode: 'en', flag: EnglishIcon },
  { label: 'German', languageCode: 'de', flag: GermanIcon },
  { label: 'Spanish', languageCode: 'es', flag: SpanishIcon },
  { label: 'French', languageCode: 'fr', flag: FrenchIcon },
  { label: 'Portuguese', languageCode: 'pt', flag: PortugalIcon },
  { label: 'Russian', languageCode: 'ru', flag: RussianIcon }
]

/* ==========================================================================
  HTTP Method Types
========================================================================== */
const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}

/* ==========================================================================
  Transaction types
========================================================================== */
export const TRANSACTION_TYPES = {
  BET: 'bet',
  WIN: 'win',
  ROLLBACK: 'rollback'
}

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
const TOKEN = 'admin_authtoken'
const LANGUAGE = 'admin_language'
const ADMIN_ID = 'admin_id'
const ROLE = 'operator_role'

/* ==========================================================================
Operator Roles
========================================================================== */
const OPERATOR_ROLES = {
  operator: 'OPERATOR',
  operatorUser: 'OPERATOR_USER'
}

/* ==========================================================================
Loader types
========================================================================== */
const LOADER_TYPE = {
  SCALE: 'scale',
  PULSE: 'pulse'
}

/* ==========================================================================
  TOASTER / NOTIFICATION Types
========================================================================== */
const TOASTER_TYPE = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info'
}

/* ==========================================================================
  Loader Types
========================================================================== */
const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  Table Cell Type
========================================================================== */
const TABLE_CELL_TYPE = {
  status: 'status',
  switch: 'switch',
  button: 'button',
  date: 'date',
  text: 'text',
  number: 'number',
  default: 'default',
  updateIconButton: 'updateIconButton',
  deleteIconButton: 'deleteIconButton',
  actionCell: 'actionCell',
  enableDisable: 'enableDisable'
}

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
// const gamesSectionParentRoute = '/games'
// const playersSectionParentRoute = '/players'
// const performanceSectionParentRoute = '/performance'

const ROUTE_PATHS = {
  rootPath: '/',
  login: '/login',
  changePassword: '/change-password',
  resetPassword: '/reset-password/:adminId/:token',
  settings: '/settings',
  dashboard: '/dashboard',
  dailyStatistics: '/daily-statistics',
  gameSettings: '/game-settings',
  gameList: '/games-settings/list',
  editGameSettings: '/game-settings/edit',
  users: '/users',
  transactions: '/transactions',
  gameReports: '/game-reports/',
  notFound: '/not-found'
}

/* ==========================================================================
  DIALOG Types
========================================================================== */
const DIALOG_TYPE = {
  add: 'add',
  update: 'update',
  delete: 'delete',
  view: 'view',
  hide: ''
}

/* ==========================================================================
  Miscellaneous Constants
========================================================================== */
export const DEFAULT_PAGE_NO = 1
export const DEFAULT_CURRENCY_ID = 1
export const DEFAULT_CURRENCY_NAME = 'US Dollar'
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'

const DEFAULT_GAME_ID = {
  CRASH: 1,
  MULTI_CRASH: 2,
  CHOPPER_CRASH: 3,
  SOCCER_CRASH: 4,
  PLINKO: 5,
  PYRAMID_PLINKO: 6,
  KENO: 7,
  DICE: 8,
  VIDEO_POKER: 9,
  HILO: 10,
  BLACKJACK: 11,
  LIMBO: 12,
  MINE: 13,
  GONGA_MINE: 14,
  ROULETTE: 15,
  SPACE_DICE: 16,
  COIN_FLIP: 17,

  /* =======EXA GAME ID's ======== */

  /* =======CRASH GAME ID's======== */
  AVIATOR_CRASH: 18,
  AZTEC_MAN_CRASH: 19,
  GALAXY_GRAB_CRASH: 20,
  FOLLOW_THE_ARROW_CRASH: 21,
  POWER_OF_THOR_CRASH: 22,
  CROSS: 23,
  TOWER: 24

  /* =======OTHER CRASH GAME ID's======== */
  // E_PLINKO: 23,
  // E_BLACKJACK: 24,
  // E_MINE: 25,
  // E_ROULETTE: 26
  /* =================================== */

}

// Export All constant variables
export {
  TOASTER_TYPE,
  LANGUAGES,
  TOKEN,
  LANGUAGE,
  ADMIN_ID,
  ROLE,
  OPERATOR_ROLES,
  ROUTE_PATHS,
  LOADER_TYPE,
  METHOD_TYPES,
  LOADER_HANDLER_TYPES,
  TABLE_CELL_TYPE,
  DIALOG_TYPE,
  DEFAULT_GAME_ID
}

export const REPORTS_TITLE = Object.freeze({
  CRASH: 'Crash',
  PLINKO: 'Plinko',
  KENO: 'Keno',
  DICE: 'Dice',
  VIDEO_POKER: 'Video Poker',
  HILO: 'HiLo',
  BLACKJACK: 'Blackjack',
  LIMBO: 'Limbo',
  MINE: 'Mine',
  ROULETTE: 'Roulette',
  COIN_FLIP: 'Coin Flip',
  MULTI_CRASH: 'Multi Crash',
  CHOPPER_CRASH: 'Chopper Crash',
  SOCCER_CRASH: 'Soccer Crash',
  PYRAMID_PLINKO: 'Pyramid Plinko',
  GONGA_MINE: 'Gonga Mine',
  SPACE_DICE: 'Space Dice',
  TOWER: 'Tower',
  CROSS: 'Cross'
})

export const maxOddGameId = ['1', '2', '3', '4', '8', '10', '12', '13', '14', '16', '17']
export const minOddGameId = ['1', '2', '3', '4', '8', '10', '12', '13', '14', '16', '17']
export const houseEdgeGameId = ['1', '2', '3', '4', '5', '6', '7', '8', '10', '12', '13', '14', '16', '17']
export const minAutoRateGameId = ['1', '2', '3', '4']
